import API from '../../api'

export const companyStaff = {
  namespaced: true,

  state: () => ({
    isLoading: false,
    isError: false,
    data: null,
    meta: {}
  }),
  mutations: {
    setAccount(state, payload) {
      state.data = payload
    }
  },

  getters: {

  },

  actions: {
    async reqBase({state}, params) {
      state.isLoading = true
      try {
        const res = await API.adminCompanies('get', 'users', params)
        state.isLoading = false
        state.data = res.data.data
        state.meta = res.data.meta
        state.isError = false
        state.error = null
      } catch (error) {
        state.error = error
        state.isError = true
        state.isLoading = false
      }
    }
  }
}